export default {
  SET_SELECTED_PAYMENT (state, value) {
    state.selectedPayment = value
  },
  SET_TRANSACTION_PRODUCT (state, val) {
    state.transactionProduct = val
  },
  SET_TRANSACTION_PAYMENT (state, val) {
    state.transactionPayment = val
  },
  SET_TYPE_TRANSACTION (state, val) {
    state.transactionTypes = val
  },
  SET_HISTORY_TRANSACTION (state, val) {
    state.transactionHistory = val
  },
  DELETE_TRANSACTION_PRODUCT(state) {
    state.transactionProduct = null
  },
  DELETE_TRANSACTION_PAYMENT(state) {
    state.transactionPayment = null
  },
  DELETE_TRANSACTION_TYPES(state) {
    state.transactionTypes = []
  },
  DELETE_TRANSACTION_HISTORY(state) {
    state.transactionHistory = null
  }
}